import { Check } from 'lucide-react';
import type { ServiceItem } from '../types';

interface ServiceCardProps {
  service: ServiceItem;
  accentColor: string;
}

/**
 * Extracts the text color class from a combined color class string
 * @param colorClass - Combined Tailwind classes like "text-emerald-600 bg-emerald-50 border-emerald-200"
 * @returns The text color class only
 */
const extractTextColor = (colorClass: string): string => {
  const textColorMatch = colorClass.match(/text-\S+/);
  return textColorMatch ? textColorMatch[0] : 'text-slate-600';
};

const ServiceCard: React.FC<ServiceCardProps> = ({ service, accentColor }) => {
  const textColor = extractTextColor(accentColor);

  return (
    <article className="bg-white rounded-xl p-6 border border-slate-100 shadow-sm hover:shadow-md transition-shadow h-full flex flex-col">
      <h4 className="text-lg font-bold text-slate-900 mb-2">{service.title}</h4>
      <p className="text-slate-600 text-sm mb-4 flex-grow">{service.description}</p>

      <ul className="space-y-2 mt-auto" aria-label="Features">
        {service.features.map((feature) => (
          <li key={feature} className="flex items-start">
            <div className="mt-0.5 min-w-[16px] flex justify-center" aria-hidden="true">
              <Check size={14} className={textColor} />
            </div>
            <span className="ml-2 text-xs font-medium text-slate-500">{feature}</span>
          </li>
        ))}
      </ul>
    </article>
  );
};

export default ServiceCard;
